import React from 'react'
import './tableHeader.css'

class TableHeader extends React.Component {
    constructor(props) {
        super(props)
    }
    render(){
        return(
            <div className='table_header_style'>
                <p className='fileName_bg_style'>文件名</p>
                <div className='seg_style'></div>
                <p className='modify_time_style'>修改时间</p>
            </div>
        );
    }
}

export default TableHeader